import JsonLine      from './Line/JsonLine';
import RawOutput     from './RawOutput';
import IncludeBraces from '../Options/IncludeBraces';

export default class JsonOutput extends RawOutput {

    static line = JsonLine;

    static availableOptions = [IncludeBraces];

}